export default {
  uiFeedback: { loading: '正在加载…', noMatches: '没有符合当前搜索的记录', clearSearch: '清除搜索', retry: '重新加载', retrySave: '重试保存' },
  legacyAssigned: {"title":"获取 SAP 已分配款号","scope":"仅获取分配给我的款号，按生产批次生成委托书。","years":"商品年度","total":"共 {count} 个款号／批次","refresh":"刷新数量","generate":"生成委托书","stop":"停止后续导入","stopping":"正在完成当前批次，请稍候…","running":"正在获取资料并生成，已处理 {count} 项…","finished":"获取完成","summary":"新建 {created} · 已有 {existing} · 补齐 {updated} · 跳过 {skipped} · 失败 {failed}","style":"款号 · 生产批次","state":"处理状态","result":"结果／待补资料","loadFailed":"获取失败，可重新获取；已生成的委托书不会重复创建。","designerOnly":"此入口仅供设计师获取分配给本人的款号。","technical":"来源：SP0120 款号／担当／计划数量、SP0200 历史担当兼容、SP0180 颜色尺码。先读当前 {system} 环境 legacy；点击生成后，缺资料的款号按原生产批次补查 SP0110、SP0060，每个请求最多查询一款，失败停止后续查询。新单待录入；已有本人草稿只补空白商品信息和未初始化的数量矩阵，保留 DS 负责人、已填内容与原编号。","states":{"CREATED":"已生成","EXISTING":"已有委托书","UPDATED":"已补齐资料","SKIPPED":"已跳过","FAILED":"失败"},"reasons":{"changed":"担当、年度或品牌已变更，请刷新后重试。","ambiguous":"同一款号批次存在重复来源，请联系管理员核对。","invalidIdentity":"款号或生产批次格式不完整。","cancelled":"SAP 已标记取消。","failed":"本项创建失败，请重试；仍失败时联系管理员查看日志。"},"notes":{"nameMissing":"品名待补充","dimensionsMissing":"颜色／尺码待接收","baseSizeMissing":"样衣尺码待选择","quantityMissing":"部分计划数量尚未收到","quantityInvalid":"部分计划数量异常，待核对"},"sapIncomplete":"SAP 尚未返回完整品名、颜色或尺码，未生成空白委托书，请核对 SAP 资料后重试。"},
  sapProgress: {"states":{"NOT_QUEUED":"待写入 PO 队列","PENDING":"待 PO 取数","PO_CONSUMED":"PO 已取数","UNAVAILABLE":"需要核对"},"hint":"四项资料接口成功后写入 IF_ModelProgress（状态 900）。PO 清除该记录 FLAG 并写入 XDATETIME 后，点击下方按钮核对并更新任务；PO 已取数不代表 SAP 最终入账。","extractedAt":"PO 抽取时间：","payload":"查看 SP0250 JDBC 字段","continue":"同步状态／核对 PO 取数","jdbcLog":"JDBC 交接记录（非 SAP 回执）","environmentMismatch":"当前 SAP 环境与 SP0250 队列的 PO 接收环境不一致，请核对 EADS_SP0250_SYS_GBN。","invalidIdentity":"委托编号、款号或批次超出 SP0250 legacy 字段范围。","rowChanged":"SP0250 队列记录缺失或已被更改，请核对 PO 和数据库记录。","readFailed":"暂时无法读取 SP0250 队列，请检查 legacy 表与数据库权限。"},
  sapBatch: {"query":"查询 SAP 批次（SP0210）","selection":"SAP 生产批次","initial":"SAP 暂无批次，使用首批 00","refreshRequired":"SAP 查询结果已失效，请重新查询款号和批次","batchUnavailable":"SAP 未返回此批次，请重新查询后选择","sheetExists":"这个款号和生产批次已有委托书，请打开已有委托书"},
  usedParts: {
  "title": "使用部位",
  "description": "查看现行材料使用部位目录、分类代码与名称。此页只读。",
  "refresh": "刷新",
  "count": "现行目录 {total} 项 · 启用 {active} 项 · 当前显示 {shown} 项",
  "sourceHint": "现行名称来自 DS 使用部位字典；分类代码及原名来自旧库同代码记录。未提供分类名称，不按代码前缀推测。中文显示名可能保留英文或韩文原值。",
  "unavailable": "旧库分类资料暂不可读，仍显示 DS 现行目录。",
  "search": "搜索代码、分类或名称",
  "allSections": "全部分类代码",
  "empty": "没有匹配的使用部位",
  "section": "分类代码（旧库）",
  "code": "部位代码",
  "nameZh": "中文显示名",
  "nameKo": "韩文名称",
  "nameEn": "英文名称",
  "status": "DS 状态",
  "active": "启用",
  "inactive": "停用",
  "sourceName": "旧库原名",
  "legacyOnly": "仅存在于旧库（尚未进入 DS 现行目录）",
  "checkedAt": "读取时间："
},
  integrationReadiness: {
    recentFailure: "最近过程执行有失败",
    onlyImplemented: "只看应用已实现／接收过程齐备",
  "counts": "共 {total} 个 · 应用已实现 {implemented} 个 · JDBC过程齐备 {jdbc} 个 · 当前显示 {shown} 个",
  "hint": "应用实现与数据库接收过程分别统计；过程存在、权限具备及历史成功记录均不能单独证明当前端到端接通。",
  "kind": {
    "application": "应用",
    "soap": "SOAP 接收",
    "jdbc": "JDBC → PO → ABAP Proxy（异步）"
  },
  "deployment": {
    "present": "接收过程齐备",
    "partial": "接收过程不齐",
    "missing": "接收过程缺失",
    "unknown": "部署状态待核对"
  },
  "configured": "应用接收配置已具备",
  "notConfigured": "应用接收配置未齐备",
  "checkedAt": "本环境读取时间：",
  "jdbcHint": "写入旧库，不代表已同步到 V2。PI 路由及消费契约仍需联调。下列仅为 sap_push 账号的过程执行记录；共享过程的记录不能归为某一个接口，未记录或回滚不代表从未调用。",
  "soapHint": "代码与本环境应用配置分开展示；尚需 SAP 端地址、认证、报文及回执联调确认。",
  "routine": "接收过程",
  "deployed": "存在",
  "permission": "sap_push 可执行",
  "success": "历史成功次数",
  "failure": "历史失败次数",
  "latest": "最近过程结果",
  "unknown": "未知",
  "yes": "是",
  "no": "否",
  "noReceipt": "无可展示记录"
},
  fabricUpdate: {
    retry: '重试',
    title: '面料资料更新待确认', sent: '委托书已发给工厂，此处不再更新面料资料。',
    hint: '关联面料有新的资料。请核对差异后确认；仅更新已使用的同一面料，保留用量、价格及使用位置。',
    saveFirst: '请先保存或取消页面上尚未保存的修改。', row: '材料第 {seq} 行',
    accept: '确认更新', decline: '保留本单资料',
    confirm: '确认用最新面料资料更新这些已有行？已批准的设计将按现行规则重新确认。',
    declineConfirm: '本次保留委托书资料？同一版本不再提醒，面料再次更新后仍可提醒。',
    fields: { materialCode:'系统面料代码',brandMaterialCode:'品牌编号',materialNm:'面料名称',materialAlias:'供应商货号',vendorNm:'供应商',composition:'成分',finishing:'后整理' },
  },

  patternParts: {
  "title": "版型测量点",
  "description": "维护常用测量点、三语名称与量法；委托书按代码引用，不改写历史资料。",
  "add": "新增测量点",
  "configure": "设置测量点 {code}",
  "code": "主代码",
  "name": "测量点名称",
  "family": "部位族",
  "aliases": "别名代码",
  "qualifier": "限定词（参考）",
  "source": "量法来源",
  "evidence": "历史使用单数",
  "categories": "适用模板代码",
  "unrestricted": "留空表示不限模板；多项用分号分隔",
  "unit": "单位",
  "gradeSmall": "向小码放码",
  "gradeLarge": "向大码放码",
  "tolPlus": "正允许值",
  "tolMinus": "负允许值",
  "status": "状态",
  "sortOrder": "排序",
  "enabled": "启用",
  "inactive": "已停用",
  "originalNames": "旧库原名",
  "legacyReview": "旧库原文；中文译文待版师核对",
  "search": "搜索代码、别名、名称或量法",
  "summary": "{points} 个测量点 · {families} 个部位族 · {aliases} 个别名",
  "loadFailed": "测量点配置加载失败，请刷新重试；已填写资料保留。",
  "duplicateCode": "主码或别名已存在，不能指向两个测量点。",
  "duplicatePoint": "同一部位族中存在相同名称及限定词，或相同韩文名及量法。",
  "translationsRequired": "已确认的测量点须填写完整的中韩英名称及量法。",
  "notFound": "测量点不存在。",
  "inUse": "测量点已被模板或委托书引用，请改为停用。",
  "removeConfirm": "删除测量点 {code}？已被引用的测量点只能停用。",
  "families": {
    "NECK": "领口",
    "SHLDR": "肩背",
    "SLEEVE": "袖",
    "CHEST": "胸背",
    "WAIST": "腰部",
    "HIP": "臀部",
    "RISE": "裆部·内长",
    "LENGTH": "衣长·下摆",
    "LEG": "腿围",
    "POCKET": "口袋",
    "HOOD": "帽",
    "TRIM": "附件"
  },
  "statuses": {
    "CONFIRMED": "已确认",
    "DRAFT": "待确认"
  },
  "sources": {
    "STANDARD": "标准定义",
    "LEGACY": "旧库原文"
  },
  "languages": {
    "zh": "中文",
    "ko": "韩文",
    "en": "英文"
  }
},
  trimUnits: { piece: '个', strand: '根' },
  sapSync: {
  "completionRecord": "本地同步完成记录（未发请求）",
  "preparedEvent": "本地待传进度（尚未发送）",
  "open": "核对／补传",
  "fullMode": "委托书完整回传",
  "singleMode": "仅测试 SP0070",
  "testStyle": "本次测试款号",
  "sourceStyle": "原款号：{style}",
  "intro": "依次发送 D-BOM、设计确认、原料确认、纸样确认；成功后写入 SP0250 队列。已成功且参数未变的项跳过。测试参数不回写委托书。",
  "coreComplete": "四项资料接口成功，请继续核对 SP0250 的 PO 取数状态。",
  "mockCoreComplete": "四项接口模拟完成，未向 SAP 发送，不更新委托书同步状态。",
  "progressPending": "保留历史未映射进度事件 {count} 条（本次不补传）",
  "progressHint": "四项资料接口成功后写入 IF_ModelProgress（状态 900）。PO 清除该记录 FLAG 并写入 XDATETIME 后，点击下方按钮核对并更新任务；PO 已取数不代表 SAP 最终入账。",
  "reviewNotes": "查看发送顺序与字段核对提示",
  "orderNote": "本次编排采用 SP0070 → SP0160 → SP0190 → SP0170。后三项顺序已有运维确认；SP0070 的位置是当前实施方案，尚需 CE2 联调验证。一次失败即停止，不自动重试。",
  "mappingNote": "候选值：设计日期取设计师岗位确认日，原料日期取面辅料采购完成日，纸样日期取基准尺寸与尺寸规格均完成的日期。担当取本单设计／面料采购／版师工号。纸样标志 1 来自旧接口示例；取消确认不自动推断标志。日期格式 YYYYMMDD，可临时调整后重新分析。",
  "confirmationFields": "三项确认字段",
  "thisSend": "本次发送值（临时）",
  "simulate": "模拟发送未完成项",
  "sendRemaining": "发送／继续未完成项",
  "awaitingChannel": "待接通 · 未发送",
  "invalidOperation": "该接口不属于委托书核心回传流程",
  "previousRequired": "请先完成前序接口；顺序或参数已经变化，请重新分析。",
  "retryInDialog": "请打开本单“推送给 SAP”的完整回传窗口，核对后继续未完成项。SP0250 待传记录不能作为 SOAP 请求重发。",
  "states": {
    "READY": "待发送",
    "SUCCESS": "已成功",
    "FAILED": "失败",
    "SENDING": "发送中",
    "RECONCILE": "结果待核对"
  },
  "fields": {
    "MainFixedDate": "设计确认日期",
    "DSN_NO": "设计师工号",
    "MaterialFixedDate": "原料确认日期",
    "PUR_NO": "面料采购工号",
    "PatternFixedDate": "纸样确认日期",
    "PATN_NO": "版师工号",
    "ConfirmPatnYN": "纸样确认标志"
  },
  "missing": {
    "MainFixedDate": "设计确认日期为空；测试可发送空节点，正式发送需完成对应确认。",
    "DSN_NO": "设计师工号为空，请核对。",
    "MaterialFixedDate": "原料确认日期为空；测试可发送空节点，正式发送需完成对应确认。",
    "PUR_NO": "面料采购工号为空，请核对。",
    "PatternFixedDate": "纸样确认日期为空；测试可发送空节点，正式发送需完成对应确认。",
    "PATN_NO": "版师工号为空，请核对。",
    "ConfirmPatnYN": "纸样确认标志为空，请按 SAP 口径核对；不自动推断取消值。"
  },
  "completed": "资料接口已成功，本地同步状态已记录。SP0250 的交接状态见下方；SAP 最终入账需在 SAP 核对。",
  "testOnly": "本次为替代款号或临时确认值的测试，不更新原委托书同步状态。请使用本单款号和当前业务值完成同步。",
  "finalize": "确认同步完成（不重发 SAP）",
  "workClosed": "SAP 回传已完成；本岗位确认与工厂交付仍独立跟进。修改回传内容后需重新同步。",
  "needsSync": "回传内容或确认信息已变化，请核对后重新同步 SAP。",
  "sheetStates": {
    "NOT_SYNCED": "未同步",
    "SYNCED": "SAP 已同步",
    "NEEDS_SYNC": "待重新同步 SAP"
  }
},
  sapUsage: {
    "title": "涉及的 SAP 接口",
    "readDirection": "从 SAP 取数 → 企划草稿",
    "writeDirection": "DS → SAP 回传",
    "readHint": "先通过 SP0210 查询生产批次，再按所选批次获取 SP0110 主资料及 SP0060 补充资料；相同草稿请求不重复调用。",
    "writeHint": "完整回传依次发送四个核心接口；也可切换为仅测试 SP0070。岗位完成与 SAP 发送独立，所有发送都由人工点击开始。",
    "priority": "SP0070 → SP0160 → SP0190 → SP0170 → SP0250（JDBC 交接至 PO）",
    "expandRead": "查看接口名称与字段",
    "expandWrite": "查看回传接口清单（{count} 项）",
    "collapse": "收起接口清单",
    "statusHint": "“实现状态”来自当前代码；“旧清单状态”来自 2026-08-26 接口清单，不能代表当前环境可用或本次已发送。",
    "implementation": "实现状态",
    "inWorkflow": "已接入当前流程",
    "operationOnly": "底层调用已实现，业务发送未接入",
    "notImplemented": "尚未实现",
    "legacyStatus": "旧清单状态",
    "legacyEnabled": "标记为启用",
    "legacyDisabled": "标记为未启用",
    "transport": "调用通道",
    "transports": {
      "soap": "SOAP → SAP",
      "jdbc": "旧 JDBC → ABAP Proxy；待核对接入方式"
    },
    "requestRoot": "SOAP 请求根",
    "contract": "WSDL 文件",
    "soapFields": "请求字段 / 节点",
    "referenceFields": "旧清单参考字段",
    "coverageGap": "SP0070 不代表整张委托书已同步。企划属性、订单数量、独立确认、流程进度、QC 和纸样文件需要分别核对回传范围；没有明确契约的资料仍留本地。",
    "roles": {
      "batch": "查询生产批次",
      "progress": "JDBC 状态交接",
      "primary": "① 主取数",
      "supplement": "② 补充取数",
      "send": "本窗口发送",
      "confirmation": "已接入完整回传",
      "evaluate": "需评估接入",
      "hold": "待确认使用范围"
    },
    "interfaces": {
      "SP0210": {"title":"SAP 生产批次","purpose":"查询该款号已有的生产批次，默认最新批次，可手动选择。","note":"WSDL 返回 StyleCD / StyleCDSeq，不返回独立 D-BOM 编号。批次用于后续取数和建单，委托书修订版本独立。"},
      "SP0110": {
        "title": "款式主数据",
        "purpose": "获取年度、季节、售价、入库要求日、担当、颜色尺码及企划数量。",
        "note": "必需查询；不提供销售月、性别和三级分类，缺失资料由企划补充。"
      },
      "SP0060": {
        "title": "款式资料与企划数量",
        "purpose": "补充品名、颜色尺码范围及主接口未提供的企划数量。",
        "note": "在 SP0110 成功后查询；不是列出全部款号的接口。已获取的有效值优先保留，冲突项提示核对。"
      },
      "SP0070": {
        "title": "委托书 D-BOM",
        "purpose": "发送面料、辅料、版型尺寸、配色、设计备注及图片 / 附件路径。",
        "note": "12 个头字段、6 个明细段；确认日期、流程履历及 QC 不在其专用数据段内。收到成功回执后仍需在 SAP CS03 核对实际内容。"
      },
      "SP0160": {
        "title": "设计确认",
        "purpose": "回传设计确认日期与设计担当，更新 SAP D-BOM 设计确认。",
        "note": "已接入完整回传，日期取设计师岗位确认日、担当取本单设计师工号；测试可临时调整。请求根含 Sel_Out，但它是写接口。"
      },
      "SP0190": {
        "title": "原料确认",
        "purpose": "回传原料确认日期与采购担当，更新 SAP 原料确认。",
        "note": "已接入完整回传，日期取面辅料采购完成日、担当取本单面料采购工号。位于设计确认之后、纸样确认之前。"
      },
      "SP0170": {
        "title": "纸样确认",
        "purpose": "回传纸样确认标志、版师工号和确认日期。",
        "note": "已接入完整回传。基准尺寸和尺寸规格均完成才预填确认日期，确认标志 1 来自旧清单示例；撤销值不推断，SP0070 顺序位置仍需 CE2 验收。"
      },
      "SP0250": {"title":"开发进度与人员","purpose":"四项资料成功后，向 legacy.IF_ModelProgress 写入状态 900 和实际操作人员，供 PO 抽取。","note":"用户提供的 PO JDBC SQL 契约。逐条保留状态和抽取证据；FLAG 清除仅代表 PO 已取数，SAP 业务回执暂未提供。"},
      "SP0240": {
        "title": "全流程节点确认",
        "purpose": "集中传送设计、纸样、原料、用量的确认日期及担当，更新研发进度表。",
        "note": "旧清单未启用；运维仅明确 CE3 不使用，CE2 范围仍待确认。与独立确认接口部分重叠，不能直接替代或重复发送。"
      },
      "SP0310": {
        "title": "QC 检验结果",
        "purpose": "回传 QC 类型、轮次、检验结果及拒绝原因。",
        "note": "本地 QC 已可录入，回传未接入；旧清单为异步 JDBC 通道，当前目录缺 WSDL。CE3 不使用，CE2 需确认，并明确异步回执。"
      },
      "SP0320": {
        "title": "纸样文档",
        "purpose": "单独登记纸样文件路径、文件大小、分类和进行阶段。",
        "note": "旧清单未启用；有 WSDL，尚未接入。需明确纸样附件用途、阶段码及 SAP 可访问路径；与反方向同号 SP0320 是不同接口。"
      }
    }
  },
  sapDebug: {
  "close": "关闭",
  "open": "推送给 SAP",
  "title": "SAP 回传分析与测试",
  "intro": "先核对字段，再手动发送。测试时可在文件头修改款号 StyleCD，所有明细自动同步；仅用于本次请求，不修改委托书。生产次数、委托编号与目标系统保持锁定。",
  "styleTarget": "委托书原款号：{source} → 本次 SAP 接收款号：{target}",
  "invalidStyleCd": "请填写本次测试款号（1～30 个字符）。",
  "trimWarningTitle": "业务缺项提示（测试窗口允许发送）",
  "trimWarningHint": "CE2 测试可携带未完成资料、临时编号及未就绪辅料发送，字段由 SAP 返回真实校验结果；正式发送保留业务拦截。",
  "fieldsTitle": "字段配置",
  "section": "数据段",
  "row": "明细行",
  "rowNumber": "第 {number} 行",
  "rowCount": "{count} 行 · {empty} 个空值",
  "field": "字段 / SOAP 名称",
  "original": "系统取值",
  "sendValue": "本次发送值",
  "empty": "空字符串",
  "locked": "由当前单据或服务器配置确定",
  "noRows": "本段无明细，不发送；可新增测试行",
  "schemaHint": "所有节点类型为 xsd:string。头部 12 个节点及明细行内节点必须存在，允许空字符串；六个明细段允许 0～多行，无行则省略。空值数量仅供核对，不代表全部必填。",
  "notes": "接口约定与待核对项",
  "contractNotes": "WSDL 约束节点名称、顺序与类型，不保证业务空值可被 SAP 接受。TechPack_NO、附件可访问路径、图片类型 D/G、FileID、单价币种及辅料用量/重量口径仍需 SAP 核对；默认标记 0 仅作候选。发送成功后请在 SAP CS03 核对实际内容。",
  "relativeImage": "部分附件仍是本站相对地址，SAP 可能无法读取。请为本次请求填写 SAP 可访问的附件路径。",
  "request": "请求报文",
  "logs": "过程与传送日志",
  "response": "SAP 返回与通信信息",
  "sentRequest": "实际发送参数",
  "recentLogs": "本单最近 20 次 SP0070 记录",
  "reload": "恢复系统取值",
  "analyze": "重新分析参数",
  "reanalyze": "参数有修改，请重新分析后发送",
  "send": "发送到 {system}（{style}）",
  "simulate": "执行模拟推送",
  "analyzed": "字段及预检分析完成，尚未调用 SAP。",
  "started": "开始发送：{adapter} / {system}，SAP 接收款号：{style}。",
  "waiting": "正在等待接口返回，通常需要约 35 秒。请勿重复发送。",
  "success": "已收到 SAP 成功回执 XSTAT=S。",
  "mockSuccess": "模拟执行成功，未发送到真实 SAP。",
  "mockNotice": "当前适配器为 mock，仅模拟执行，不会与真实 SAP 通信。",
  "failed": "本次传送失败，请查看下方回执。",
  "reconcile": "传送结果待 SAP 对账，已阻止重复发送。",
  "reconcileRetry": "本次处理结果尚未确认，日志已保留；测试模式允许再次手动发送。",
  "testRetryEnabled": "CE2 测试模式：允许重复发送",
  "testRetryHint": "超时、空回执或失败记录不再阻止下一次测试。请求结束后可直接再次发送；修改参数后需重新分析。每次点击都会重新提交到 SAP，历史结果保留，认证保护仍有效。",
  "blocked": "尚不能发送，请处理以下事项",
  "stale": "委托书、辅料映射或配置已变化，请恢复系统取值后重新核对。",
  "identityChanged": "生产次数、委托编号和目标系统不能在测试参数中改写。",
  "adapterUnavailable": "当前 SAP 适配器尚未实现。",
  "notConfigured": "真实 SAP 通道未启用或配置不完整。",
  "circuitOpen": "认证熔断已开启，当前不发送。请核对账号后由管理员处理。",
  "timeout": "接口超时 {seconds} 秒",
  "authRemaining": "认证失败剩余额度：{count}",
  "sections": {
    "header": "文件头（12 字段）",
    "MainDtl_Material": "面料明细",
    "DesignMemo": "设计备注",
    "MainDtl_Pattern": "版型尺寸",
    "MainDtl_ColorWay": "配色明细",
    "DtlImg": "图片资料",
    "ModelSubMaterial": "辅料明细"
  },
  "fields": {
    "StyleCD": "款号",
    "StyleCDSeq": "生产次数",
    "AttachmentFilePath": "附件路径",
    "ModelCD": "委托编号",
    "ItemCD": "品类代码",
    "CAD_NO": "CAD 担当编号",
    "TechPack_NO": "Tech Pack 担当编号",
    "DesignerSAPYN": "设计 SAP 标志",
    "TechPackSAPYN": "Tech Pack SAP 标志",
    "FileSize": "文件大小（字节）",
    "ORGFILE": "原文件名",
    "SysGBN": "目标系统",
    "MaterialCD": "面料代码",
    "MaterialItemCD": "面料品类／原素材别名",
    "Yardage": "面料用量",
    "Width": "幅宽",
    "ColorMatchPartCD": "配色部位",
    "MaterialAlias": "面料名称／别称",
    "MaterialMemo": "面料备注",
    "UnitPrice": "单价（接口不含币种节点）",
    "UsedPartCD": "使用部位代码",
    "TagColorCD": "适用颜色代码",
    "DSGNK": "供应商／DSGNK",
    "DesignMemo": "设计备注内容",
    "Seq": "部位序号",
    "SizeCD": "尺码代码",
    "PatternPartCD": "部位代码",
    "PatternPartNm": "部位名称",
    "StdSize": "样衣尺码",
    "Size": "尺寸值",
    "TorlnceL": "左档差",
    "TorlnceR": "右档差",
    "Measurement": "测量方法",
    "PlusTol": "正允许值",
    "MinusTol": "负允许值",
    "ModelColorWaySeq": "配色序号",
    "CoreColorNM": "配色名称",
    "StdColorCD": "配色标准代码",
    "IKIND": "图片类型",
    "FileID": "SAP 文件编号",
    "SubMaterialCD": "辅料 SAP 物料号",
    "SubMaterialUsedPart": "辅料使用部位",
    "SubMaterialMemo": "辅料名称／内容",
    "Gauge": "规格",
    "GaugeUnit": "规格单位",
    "SubMaterialColorNm": "辅料颜色名",
    "RealYardage": "辅料用量",
    "Unit": "用量单位",
    "POSNR": "BOM 项目号",
    "Weight": "实际用量／重量",
    "WeightUnit": "实际用量／重量单位",
    "ZUNITID": "SAP 单位标识"
  }
},
  packRefinement: { completePattern: '完成版型尺寸', patternDone: '版型尺寸已完成' },
  app: {
    name: 'Design Sheet',
    shortName: 'Design Sheet',
    wordmarkDesign: 'design',
    wordmarkSheet: 'sheet',
    company: 'E·LAND China',
  },

  common: {
    close: '关闭',

    confirm: '确定',
    cancel: '取消',
    save: '保存',
    saved: '已保存',
    deleted: '已删除',
    saveDraft: '保存草稿',
    submit: '提交',
    delete: '删除',
    actions: '操作',
    edit: '编辑',
    detail: '详情',
    expandDetails: '展开详情',
    collapseDetails: '收起详情',
    search: '查询',
    select: '请选择',
    reset: '重置',
    export: '导出',
    back: '返回',
    loading: '加载中…',
    refresh: '刷新',
    noData: '暂无数据',
    total: '共 {n} 条',
    operation: '操作',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    createdBy: '创建人',
    yes: '是',
    no: '否',
    language: '语言',
  },

  auth: {
    homeHeadlineFirst: '从设计稿，',
    homeHeadlineLast: '到技术包。',
    homeDescription: '整理款式资料，协同面辅料与版型尺寸，完成生产交接。',
    homeHeroAlt: '服装设计工作室，摆放着人台、面料与设计手稿',
    homeFeaturesLabel: '工作内容',
    homeDesignTitle: '设计资料',
    homeDesignDescription: '导入设计稿，整理款式信息。',
    homeCollaborateTitle: '协作录入',
    homeCollaborateDescription: '共同完善面辅料与版型尺寸。',
    homeTechPackTitle: '技术包',
    homeTechPackDescription: '集中核对、预览与导出。',
    loginHelp: '登录帮助',
    homeNavigation: '首页导航',
    homeCopyright: '© 2026 E·LAND GROUP. All Rights Reserved.',
    loginHelpScanTitle: '企业微信登录',
    loginHelpScanDescription: '请使用企业微信扫描页面二维码登录。',
    loginHelpAccessTitle: '登录支持',
    loginHelpAccessDescription: '如无法登录或需申请开通，请通过企业微信联系孟宪秋。',
    homeAboutTitle: '关于 Design Sheet',
    homeAboutGoalTitle: '项目目标',
    homeAboutDescription: 'Design Sheet 汇集款式资料、面辅料、版型尺寸与技术包，支持各岗位协作完成从设计到生产的交接，减少重复录入，并保留修改与确认记录。',
    homeAboutRoles: '支持商品企划、设计师、面辅料采购、版师、生产管理及设计室长协作。',
    homeAboutProgressTitle: '当前进度',
    homeAboutProgressDescription: '目前处于 ND、EE 品牌测试阶段，已支持资料导入、协作录入、设计审批及 Tech Pack 预览与导出。订货系统与 SAP 数据对接仍在验证，后续将继续完善数据衔接和操作体验。',
    homeAboutFeedbackTitle: '意见反馈',
    homeAboutFeedbackDescription: '如有使用问题或改进建议，请通过企业微信联系孟宪秋，并提供相关款号、操作说明或截图。',
    esiLogin: '企业微信扫码登录',
    continueWecomLogin: '继续登录',
    openWecomLogin: '打开企业微信登录页',
    qrLoading: '二维码加载中…',
    qrUnavailable: '二维码暂时无法加载',
    esiNoAccess: '此账号尚未开通 Design Sheet，请联系管理员',
    testAccountLogin: '测试账号登录',
    loginTitle: '登录',
    loginSubtitle: '请输入账号和密码',
    username: '账号 / 工号',
    password: '密码',
    usernamePlaceholder: '请输入账号或工号',
    passwordPlaceholder: '请输入密码',
    login: '登 录',
    logout: '退出登录',
    logoutConfirm: '确定要退出登录吗？',
    loginSuccess: '登录成功',
    sessionKept: '服务暂时不可用，登录状态已保留。服务恢复后点击「重试」即可，无需重新输入密码。',
    retryRestore: '重试',
    changePassword: '修改密码',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    profile: '个人信息',
    department: '部门',
    roles: '角色',
  },

  about: {
    title: '关于 Design Sheet',
    desc: '软件版本信息与发布编号规则。',
    version: '软件版本',
    stage: '发布阶段',
    devStage: '开发中',
    testStage: '测试版',
    buildTime: '构建时间',
    noteSeparate: '软件版本标识应用发布。委托书阶段记录评价会、订货会或大货；记录版本是数字序号，QC 轮次另行编号。',
    versionLine: '反馈问题时请附以下版本信息:',
    rulesTitle: '版本编号规则',
    colNo: '编号',
    colWhen: '适用场景',
    rulePatch: '问题修复,递增修订号',
    ruleMinor: '新增兼容功能,递增次版本号',
    ruleMajor: '正式发布版本',
    ruleRc: '正式发布前的候选版本',
    rulesNote: '版本号唯一来源为项目根 package.json,由构建流程注入界面;本页为只读展示。',
  },
  styleRegistry: {
    overview: '款号总览', gallery: '设计资料', allYears: '全部年度', allBrands: '全部品牌', year: '商品年度', brand: '品牌',
    assignment: '设计师分配', assignmentALL: '全部分配状态', assignmentUNASSIGNED: '设计师待分配', assignmentASSIGNED: '设计师已分配',
    sheetState: '委托书', sheetsALL: '全部建单状态', sheetsWITH: '已建委托书', sheetsWITHOUT: '尚未建单',
    total: '共 {count} 条款号／批次', batchHint: '按生产批次展示；含已接收的 SAP 款号及 DS 现有款号。',
    styleCd: '款号', batch: '生产批次', name: '品名', yearSeason: '年度／季节', source: '来源',
    sourceSAP_RECEIVED: 'SAP 已接收', sourceDS_ONLY: 'DS 委托书', sourceCACHE: '本地款号缓存',
    needsAssignment: '待分配／账号待匹配', local: 'DS 内部分配', notCreated: '尚未建单', manage: '查看／分配', view: '查看详情', detail: '款号信息与分工',
    readonlyHint: '基础资料在此只读；SAP 来源字段需在 SAP 维护。品名取现有委托书或本地款号缓存。',
    linkedSheets: '关联委托书', existingHint: '已建单的负责人按具体委托书调整，保留原有审批和交接规则。', openSheet: '查看委托书',
    sapOwners: 'SAP 原分工与 DS 分配', sapValue: 'SAP 工号：{value}', inherit: '沿用 SAP 分配', unassigned: '暂不分配',
    localHint: '这里只保存 DS 内部分工，不回写 SAP。指定设计师后，可从其“我的任务”获取款号并建单。其他岗位可后续补充。',
    save: '保存 DS 分工', saved: 'DS 分工已保存', notFound: '款号不存在或不可见',
    notAssignable: '仅可分配已接收、批次明确且没有重复来源的 SAP 款号。本地缓存请先通过 SAP 建单入口确认批次。',
    useSheetAssignment: '已有委托书，请刷新后在关联委托书中调整负责人。', personChanged: '分配账号的岗位或品牌权限已变化，请在款号总览重新分配。',
  },
  styleLibrary: {
    searchCode: '搜索款号，支持输入部分款号',
    search: '搜索',
    clearSearch: '清除搜索',
    searchResults: '款号“{keyword}”的搜索结果：{count} 款',
    noSearchResults: '没有找到匹配的款号',
    noImage: '暂无款式图',
    imageLoading: '图片加载中',
    imageFailed: '图片暂无法加载',
    title: '款式库',
    eyebrow: 'STYLE LIBRARY',
    desc: '全部款式按季节、品类、状态浏览；点开文件夹查看款式',
    mode: '查看方式',
    bySeason: '按季节',
    byCategory: '按品类',
    byStage: '按状态',
    styles: '{count} 款',
    loading: '加载中…',
    empty: '还没有款式',
    emptyHint: '委托书建立后会自动出现在这里，按季节、品类、状态归类',
    more: '还有 {count} 款未展示',
    loadMore: '加载更多',
    loadedOf: '已显示 {loaded} / {total} 款',
    ungrouped: '未分类',
    phaseDesign: '设计稿',
    phaseSample: '样衣',
    phaseProduction: '大货',
  },
  fabricStockInit: {
    title: '面料库存',
    desc: '把已经在仓库里的面料库存一次性录入系统。期初流水独立记账，不会记成采购入库或盘盈，也不覆盖现有余额。',
    downloadTemplate: '下载期初模板',
    importInit: '导入期初库存',
    tabIntro: '怎么用',
    tabBatches: '导入记录',
    howTitle: '期初导入的四个步骤',
    how1: '点「下载期初模板」：系统按当前品牌带出正式面料与颜色（含坯布 GRE），一行一个「面料 + 颜色」。',
    how2: '在模板里填「存放地点代码」「期初库存数量」「库存单位」，同一颜色放多个地点时复制该行改地点。',
    how3: '点「导入期初库存」上传：先校验并预览，错误会定位到 Excel 行号与字段。',
    how4: '核对无误后确认入账，整批一次性成功；之后可在「导入记录」查批次与明细。',
    rulesHint: '数量留空表示不处理；填 0 表示已盘点、期初为零（保留盘点记录）；单位只能是 M / YD / KG，不做自动换算。',
    batchNo: '批次号',
    stockDate: '盘点基准日期',
    status: '状态',
    rows: '行数统计',
    quantity: '数量汇总',
    file: '原文件',
    people: '登记人 / 时间',
    detail: '明细',
    revoke: '撤销整批',
    noBatches: '还没有期初导入记录',
    rowCounts: '共 {total} 行（可入账 {ok} · 零库存 {zero} · 跳过 {skipped}）',
    statuses: { COMMITTED: '已入账', REVOKED: '已撤销' },
    stepFile: '选择文件',
    stepPreview: '核对预览',
    stepDone: '完成',
    fileRequired: '请先选择 Excel 文件',
    dateRequired: '请选择盘点基准日期',
    stockDateHint: '整批统一一个日期，不需要在 Excel 里逐行填写；登记时间与它分开保存。',
    memo: '批次备注',
    totalRows: '文件总行数',
    committable: '可入账',
    zeroRows: '期初为零',
    skipped: '空数量跳过',
    errorRows: '错误行',
    qtyByUnit: '按单位汇总：',
    blockedByErrors: '存在错误行，整批不能入账。请修正后重新上传，避免部分成功导致重复记账。',
    rowNo: '行号',
    fabricCode: '面料编码',
    colorCode: '颜色',
    location: '存放地点',
    unit: '单位',
    result: '校验结果',
    lineStatuses: { COMMITTED: '可入账', ZERO: '期初为零', SKIPPED: '已跳过', ERROR: '错误' },
    confirmHint: '确认后整批一次性入账；同一份文件重复提交不会产生第二份期初。',
    upload: '上传校验',
    back: '返回修改',
    confirm: '确认入账',
    doneTitle: '期初库存已入账',
    committedHint: '批次 {batch} 已入账，可在「导入记录」查看明细。',
    reusedHint: '这份文件之前已经入账过（批次 {batch}），本次未重复记账。',
    revokeTitle: '撤销整批期初库存',
    revokeReasonHint: '请填写撤销原因',
    revokeReasonRequired: '撤销必须填写原因',
    revokeReason: '撤销原因',
    revoked: '已撤销，已生成反向流水',
    downloadOriginal: '下载原文件',
    noOriginal: '该批次没有留存原文件（保存时对象存储不可用）。',
    tabStock: '库存余额',
    stockKeyword: '搜索面料编码或名称',
    stockOnlyMoved: '只看有出入库的',
    stockEmpty: '没有符合条件的面料',
    colFabric: '面料',
    colCategory: '品类',
    colNet: '当前库存',
    colIn: '累计入库',
    colOut: '累计出库',
    colLastTxn: '最后变动',
    colColors: '颜色数',
    templateTitle: '下载期初模板',
    templateScope: '导出范围',
    templateSearch: '筛选面料编码或名称',
    templateSelected: '已选 {n} 个面料',
    templateAllHint: '不勾选则导出当前品牌全部正式面料',
    estimatedRows: '预计 {n} 行（一行 = 一个面料 + 颜色）',
    templateEmpty: '没有符合条件的面料',
    download: '下载',
    downloadResult: '下载校验结果',
    locationManage: '地点管理',
    locationHint: '存放地点取工厂主档，停用的地点不能再用于新的期初。',
    locationCode: '地点代码',
    locationName: '地点名称',
    locationNameEn: '英文名',
    locationAdd: '新增地点',
    locationEmpty: '还没有维护任何存放地点',
    locationActive: '启用',
    locationInactive: '停用',
    templateDownloaded: '模板已下载',
  },
  fabricCodeRule: {
    noEnabledBrand: '请先在品牌管理中启用至少一个品牌。',
    title: '面料编码规则',
    eyebrow: 'SYSTEM',
    desc: '维护面料类别的字母码、两个关键因子的含义，以及每个类别下可用的关键因子取值。面料库的类别与因子下拉以此为准。',
    composeHint: '面料正式码 = 类别字母(1) + 关键因子 1(2) + 关键因子 2(3，数值补零) + 4 位序号。类别与因子 1 在这一页维护，序号由系统发放。',
    partCategory: '类别字母',
    partKf1: '关键因子 1',
    partKf2: '关键因子 2',
    partSeq: '流水号',
    category: '面料类别',
    noMeaning: '未设置含义',
    inactive: '已停用',
    kf1List: '关键因子 1 可选值',
    addKf1: '新增取值',
    editKf1: '编辑取值',
    editCategory: '编辑类别',
    code: '代码',
    nameZh: '中文名',
    nameEn: '英文名',
    used: '已用',
    status: '状态',
    enabled: '启用',
    disabled: '停用',
    disable: '停用',
    enable: '启用',
    categoryLabel: '显示名称',
    kf1Meaning: '因子 1 含义',
    kf1MeaningHint: '如：主要混纺 / 组织',
    kf2Meaning: '因子 2 含义',
    kf2MeaningHint: '如：丹尼·变量·克重 / 克重 / 盎司',
    sort: '排序',
    charImmutable: '类别字母是编码首位，登记后不可修改。',
    codeImmutable: '代码是编码第 2-3 位，登记后不可修改；不再使用请停用，不要删除。',
    configure: '配置取值 {code}',
    configureCategory: '配置类别 {code}',
    nameKo: '韩文名',
    fromDoc: '文档',
    fillFromDoc: '按文档填充三语',
    docNotFound: '文档对照表里没有这个代码',
    docNameConflict: '类别口径或现有名称与文档不同，不能仅按相同代码填充三语。请先核对含义。',
    docConflictingCodes: '同码含义／名称需核对：{codes}',
    nameLimit: '请输入英文名称；各语言名称最多 100 字。',
    showInactive: '显示停用项',
    docTitle: '与《面料代码构成与KeyFactor对照》核对',
    docHint: '左为库内现状，删除线标出不同口径；这里只提示差异，不自动改主数据。',
    docVerdict: '类别含义核对',
    docAligned: '类别含义一致',
    docMismatch: '与文档不一致',
    docMissingCategory: '库内未建档',
    docCoverage: '文档 {doc} 条 · 库内 {db} 条',
    docMissingInDb: '文档有但未建档：{codes}',
    docNotListed: '库内已建档、文档未列：{codes}',
    dropdownHint: '这里的取值直接决定面料库编辑页的下拉内容；停用后新单不可选，历史记录不受影响。',
  },
  nav: {
    integrations: "接口与同步诊断",
    dashboard: '任务与管理',
    workbench: '我的待办',
    sheet: '委托书',
    sheetList: '委托书列表',
    legacySheets: '历史委托书',
    sheetDetail: '委托书详情',
    sheetCreate: '创建委托书',
    sheetApproval: '委托书审批',
    spec: '规格录入',
    fabricWidth: '面料幅宽',
    trimAttr: '辅料信息',
    baseSize: '基准尺寸',
    materialUsage: '面料用量',
    trimUsage: '辅料用量',
    sizeTolerance: '尺寸偏差',
    sap: 'SAP 传送',
    sapTransfer: '数据传送',
    sapLog: '传送记录',
    permissions: '角色权限说明',
    admin: '系统管理',
    userManage: '用户与访问权限',
    colorDict: '颜色',
    sizeDict: '尺码',
    supplierMaster: '供应商管理',
    costConfig: '成本与汇率',
    subMaterials: '辅料管理',
    business: '业务',
    system: '系统',
    masterData: '基础数据',
    group: {
      configuration: '业务配置',
      workbench: '工作台',
      library: '历史资料',
      materials: '物料管理',
      orders: '订单与协作',
      system: '系统管理',
    },
    menu: {
      adminOverview: '管理概览',
      suppliers: '供应商资料',
      brandApproval: '品牌与审批',
      reorderProduction: '加单生产确认',
      fabricLibrary: '面料管理',
      trimLibrary: '辅料管理',
      orderManagement: '订单接收',
      factoryCollab: '工厂协作',
      masterDict: '基础字典',
      costParams: '成本与汇率',
    },
    masterDicts: '基础字典',
    roleManage: '角色权限说明',
    about: '帮助与关于',
    auditLog: '操作审计',
    sapTransfers: 'SAP 传送记录',
  },

  role: {
    ADMIN: '系统管理员',
    APPROVER: '设计室长',
    DESIGNER: '设计师',
    PRODUCTION: '生产管理',
    FABRIC: '面辅料采购',
    PATTERN: '版师',
    PLANNER: '商品企划',
    VIEWER: '只读用户',
  },

  perm: {
    mgrTitle: '用户权限管理',
    mgrHint: '默认跟随角色；给个别人单独勾权限后标记「自定义」。修改保存后，该用户需要重新登录生效。',
    searchUser: '搜索用户',
    pickUser: '← 选择一位用户开始配置',
    custom: '自定义',
    roleDefault: '当前为角色默认权限',
    resetToRole: '恢复角色默认',
    revokeHint: '保存会吊销该用户的登录状态（权限在令牌里）；正在使用的窗口最长 2 小时后自然失效。',
    saved: '权限已保存',
    desc: '本页由系统里的权限定义实时生成，不是手写文档 —— 规则改了这里立刻跟着变，可以直接对着讨论。',
    mine: '我的权限',
    myScopes: '当前可编辑的模块',
    noneEditable: '无（本角色不参与委托书录入）',
    adminNote: '系统管理员对所有模块放行，不受下表限制。',

    matrixTitle: '谁能编辑什么',
    matrixHint:
      '委托书被切成下面这些「编辑域」，每个域有固定的负责角色。各角色并行工作、互不阻塞。切换右侧的单据状态，可以看出不同状态下谁被锁住。',
    previewStatus: '按此状态查看',
    scope: '编辑域',
    approvalBound: '受设计审批约束',
    legendYes: '可以编辑',
    legendLocked: '本角色负责，但当前状态下锁定',
    legendNo: '不可编辑（只能查看）',

    stagesTitle: '分节完成标记归谁打',
    stagesHint: '同一节的多个标记可能分属不同角色 —— 面辅料节的三个标记就是三个人各打各的。',
    section: '分节',
    stage: '完成标记',
    owner: '负责角色',
    adminOnly: '仅系统管理员',

    approvalTitle: '设计审批流转',
    flowSubmit: '设计师提交',
    flowApprove: '设计室长通过',
    flowReject: '设计室长驳回',
    flowResubmit: '设计师修改后再提交',
    ruleParallel: '只审设计师负责的内容。其它角色任何时候都能录入，不看审批状态。',
    rulePendingLock: '审批中（已提交、未裁决）设计内容锁定 —— 正在审的东西不能变。',
    ruleEditAfterApprove:
      '通过之后仍可修改，但一改批准即失效、自动退回草稿，需要重新提交审批（状态历史里会留一条记录）。',
    ruleRejectMemo: '驳回必须填写意见，设计师据此修改；可以反复驳回、反复重提，每一轮都有留痕。',
    ruleCancelled: '单据作废后，所有模块一律不可编辑。',

    rolesTitle: '各角色持有的权限点',
    rolesHint: '权限点决定能不能进某个接口；上面的编辑域决定进去之后能改哪一块。两者都要满足。',
    permissionCount: '个权限点',
    myRoleNote: '当前角色为「{role}」，共 {n} 个权限点。',

    source: '数据来源：编辑域取自共享包 constants/edit-scopes.ts，权限点取自数据库的角色配置。',
  },

  editScope: {
    SOURCE_INFO: '款式来源信息',
    ORDER_QUANTITY: '订货数量修改',
    PATTERN_INFO: '版型引用信息',
    PRODUCTION_INFO: '成衣供应商',
    MANUAL_STYLE: '手工款颜色与尺码',
    MANUAL_COMMERCE: '手工款售价与数量',
    ORDER_INFO: '入库要求日期',
    DESIGN: '设计',
    COLORWAY: 'ColorWay 配色',
    USP: 'USP·设计意图',
    FABRIC_BASE: '面料信息',
    FABRIC_PROD: '面料生产列',
    TRIM: '辅料 BOM',
    CONSUMPTION: '面料用量',
    TRIM_CONSUMPTION: '辅料用量',
    PRICE: '单价',
    COST: '成本录入',
    TRIM_TECHNICAL: '辅料技术资料',
    SIZE_DEVIATION: '尺寸偏差',
    SIZE_SPEC: '基准尺寸',
    QUANTITY: '订货数量（只读）',
    ONLINE: '在线商品信息',
    QC: 'QC 委托书',
    TECHPACK_EXPORT: 'Tech Pack 最终确认',
  },

  editScopeWhere: {
    MANUAL_STYLE: '商品企划维护手工款颜色与尺码；设计师从中选择样衣尺码。',
    MANUAL_COMMERCE: '商品企划维护手工款售价、数量、订货资料和人员。',
    ORDER_INFO: '04 节：商品企划或生产管理维护入库要求日期。',
    ORDER_QUANTITY: '商品企划在委托书中修改颜色、尺码对应的订货数量，保留来源与修改记录。',
    PATTERN_INFO: '本款版师维护版型模块号和参考委托书、款号。',
    DESIGN: '01 节：设计图稿 / 主信息 / 设计 Memo / 详细图片',
    COLORWAY: '02 节：ColorWay 配色表',
    USP: '08 节：核心卖点与设计意图',
    FABRIC_BASE: '02 节面料：使用部位 / 分类 / 代码 / 名称 / 成分 / 后整理 / 供应商 / 适用颜色',
    FABRIC_PROD: '02 节面料：幅宽、单位、重量（主流程第 7 步）',
    TRIM: '02 节：辅料 BOM 的结构与属性',
    CONSUMPTION: '面料用量由版师填写',
    TRIM_CONSUMPTION: '辅料用量由设计师初填、版师核对',
    PRICE: '02 节：面料与辅料的单价、币种（成本计算用）',
    COST: '02 节成本：采购模式、FOB 报价、加工费、外包工程费、通关费；冻结成本快照',
    TRIM_TECHNICAL: '02 节：辅料颜色、规格与技术备注（版师）',
    SIZE_DEVIATION: '03 节：左右偏差与允许值（版师）',
    SIZE_SPEC: '03 节：基准尺寸、分尺码值与测量方法（版师）',
    QUANTITY: '04 节：订货数量，由前序环节确定，只读查看。',
    ONLINE: '07 节：在线商品信息',
    QC: '06 节：QC 委托书各轮次',
    TECHPACK_EXPORT: '05 节：生产管理最终确认；本款查看者可导出',
  },

  admin: {
    usersDesc: '一人一个角色。角色决定这个人能编辑委托书的哪些模块，其余模块只能查看。',
    createUser: '新建用户',
    editUser: '编辑用户',
    username: '账号 / 工号',
    usernameRequired: '请输入账号',
    usernamePattern: '账号只能用字母、数字与 . _ -',
    displayName: '姓名',
    displayNameRequired: '请输入姓名',
    role: '角色',
    roleRequired: '请选择角色',
    noRole: '未分配',
    department: '部门',
    email: '邮箱',
    locale: '界面语言',
    status: '状态',
    active: '启用',
    inactive: '停用',
    activate: '启用',
    deactivate: '停用',
    lastLogin: '最近登录',
    authProvider: '认证方式',
    authLocal: '账号密码',
    authSso: '企业微信',
    bound: '已绑定',
    searchPlaceholder: '搜索账号 / 姓名 / 邮箱',
    resetPassword: '重置密码',
    resetPasswordConfirm: '重置 {name} 的密码？系统会生成新的临时密码，该用户当前的登录会立即失效。',
    deactivateConfirm: '停用 {name}？停用后该用户立即无法登录。',
    activateConfirm: '重新启用 {name}？',
    cannotChangeOwnRole: '不能修改自己的角色，避免把自己锁在门外',
    brands: '可见品牌',
    allBrands: '全部品牌',
    noBrand: '未设置',
    brandsPlaceholder: '选择品牌，可多选',
    brandsHint: '选择明确授权的业务品牌。未启用品牌的原授权继续保留，但资料暂不可查看；权限变化在后续访问时生效。',
    adminAllBrands: '系统管理员业务查询可见所有已启用品牌；品牌管理可维护全部登记品牌。',
    noBrandConfirm: '没有选任何品牌，这个人登录后一张委托书都看不到。确定这样保存吗？',
    tempPasswordHint: '创建后系统会生成一个临时密码，只显示一次，请复制后告知本人。',
    tempPasswordTitle: '临时密码',
    tempPasswordWarn: '关闭后无法再次查看。忘了就重置一次。',
    copy: '复制',
    copied: '已复制',
    copyFailed: '复制失败，请手动选中',
  },

  status: {
    DRAFT: '草稿',
    PENDING: '审批中',
    APPROVED: '已批准',
    REJECTED: '已驳回',
    CANCELLED: '已作废',
  },

  server: {
    sapTransferInProgress: '本款已有传送尚未结束。请先核对处理结果，再决定是否重新传送。',
    sapMaintenance: '接口正在维护，未启动新传送。请稍后重试。',
    sapProbeReadOnly: '连接检查仅用于读取款式。传送委托书请从对应款号操作。',
    qcRemoveAttachmentsFirst: '请先移除本轮附件，再删除 QC 轮次。',
    qcRoundMissing: 'QC 轮次已不存在，请重新打开委托书。',
    qcRoundCompleted: '本轮 QC 已完成，请先取消完成标记后再修改。',
    rowEditConflict: '该表已更新，你的填写已保留。请重新打开委托书核对后再保存。',
    rowUndoUnavailable: '此次删除无法撤销。',
    rowUndoExpired: '已超过撤销时间，请重新录入。',

    scopeReadonly: '当前账号只能查看此部分，请由本款对应担当修改。',
    materialRowsChanged: '面料行已变化，请刷新并核对后再保存。',
    sizeRowsChanged: '尺寸行已变化，请刷新并核对后再保存。',
    stageDesignMissing: '设计稿或样衣尺码尚未填写。',
    stageDeviationMissing: '基准尺寸未填完整，或 QC 允许值不是有效数字；QC 允许值可留空。',
    sizeGradingRange: '档差计算结果不能为负数或超过 99999999.99，请核对基准尺寸和左右档差。',
    sizeNumberInvalid: '尺寸和档差最多保留两位小数，绝对值不能超过 99999999.99。',
    stageWidthMissing: '部分面料缺少有效的幅宽。',
    stageTrimMissing: '部分辅料缺少代码或适用的尺码规格。',
    stageUsageMissing: '部分面料或适用辅料缺少用量；明确无用量时可填 0。',
    patternSizeEmpty: '版型尺寸为空，或有部位、尺寸值未填写。',
    subMaterialRowsChanged: '辅料行已变化，请刷新并核对后再保存。',
    techpackNotReady: 'Tech Pack 资料确认尚未齐备，请先完成以下事项。',
    demoNoTransfer: '演示资料仅用于流程测试，不允许发送到 SAP。',
    stageMismatch: '该确认项不属于当前分节，请刷新页面后重试。',
    sapPreparationIncomplete: '请先由设计师和版师完成各自的资料确认；生产发厂核对不作为SAP推送前置。',
    packNotConfirmed: '请先由生产管理最终确认 Tech Pack。',
    testViewNoPassword: '测试视角中不能修改账号密码。',
    assigneeOnlyDraft: '只可为草稿或已驳回的委托书调整负责人。',
    assigneeMismatch: '负责人须为可查看本品牌且角色相符的启用账号。',
    testViewClosed: '测试视角已关闭或已到期，请返回管理员。',
    testViewBusinessOnly: '请选择已启用的业务账号。',
    roleNotFound: '该角色不存在。',
    adminRoleProtected: '管理员权限由系统维护，不能在此修改。',
    unknownPermissions: '权限清单包含无效项目，请刷新后重试。',
    notSubmittable: '当前单据状态不允许提交审批（草稿或已驳回才能提交）',
    nothingToWithdraw: '没有在等审批的提交，无法撤回',
    nothingToDecide: '没有在等裁决的设计内容',
    rejectMemoRequired: '驳回必须填写意见',
    badCredentials: '账号或密码错误',
    accountDisabled: '账号已停用，请联系管理员',
    esiSessionExpired: 'AI Lab 登录已失效，请重新登录',
    esiAccountNotConfigured: '尚未开通 Design Sheet，请联系管理员',
    esiPasswordManaged: '此账号使用 AI Lab 登录，无需设置本地密码',
    sapResultNeedsCheck: '上一次传送结果尚未确认，请先核对 SAP 记录，勿重复传送',
    userNotFound: '用户不存在',
    wrongPassword: '当前密码不正确',
  },
  submitCheck: {
    noFlatSketch: '「设计」节缺少设计图稿',
    noStdSize: '「设计」节缺少样衣尺码',
    noColorway: '「面辅料」节 ColorWay 至少需要一个启用的颜色',
    stageNotDone: '「{section}」节的「{stage}」尚未标记完成',
  },
  hero: {
    createTitle: '创建委托书',
    createDesc: '从订货会结果或加单结果开始一个新款；也可以从已有款号检索。',
    fromOrderFair: '从订货会新建',
    fromReorder: '从加单新建',
    reorderHint: '加单接口对接后开放（灰度中）',
    moreWays: '更多方式',
  },
  pipe: {
    toCreateHint: '最新订货会中尚未创建委托书的款式。点击进入订货会选款并创建;首次使用需先刷新一次订货会列表。',
    title: '我的款式流水线',
    desc: '从创建到发工厂，一款衣服走过的五段。数字可点，直达对应单据。',
    pendingApproval: '待审批（已提交）',
    approved: '已批准',
    techpackSent: 'Tech Pack 已确认',
  },
  audit: {
    title: '审计日志',
    desc: '系统里每一次写操作的留痕 —— 谁、什么时候、改了什么。点击一行展开变更前后对比。',
    keywordPh: '搜动作 / 目标 id',
    targetType: '对象类型',
    action: '动作',
    actor: '操作人',
    from: '开始时间',
    to: '结束时间',
    time: '时间',
    what: '做了什么',
    target: '对象',
    detail: '明细',
    before: '变更前',
    after: '变更后',
    scopes: {
      sheet: '整单', material: '面辅料', design: '设计', pattern: '版型·尺寸',
      qc: 'QC', usp: 'USP', online: '在线商品', cost: '成本', techpack: 'TechPack',
    },
  },
  sap: {
    transfer: '传 SAP',
    transferConfirm: '把委托书 {modelCd} 传送给 SAP(CE2)创建 D-BOM?发送内容与日志都会留档。',
    transferTitle: '传送给 SAP',
    transferOk: '已传送 SAP(见「SAP 传送状态」页)',
  },
  switch: {
    account: '切换测试账号(品牌×角色)',
    roleOnly: '仅切角色',
    reset: '恢复本人',
  },
  board: {
    taskArea: '任务列表',
    taskScope: '任务范围',
    scopes: { pending: '待我处理', mine: '我负责的', brand: '品牌内全部' },
    scopeHints: { pending: '按当前岗位查看需要你处理的任务。', mine: '查看本人负责的委托书，包含处理中、已完成和已作废的记录。', brand: '查看权限范围内的全部委托书。' },
    quickFilters: '快捷筛选',
    shortcutHint: '数字为本人对应事项总数；点击后清除搜索和审核状态条件，查看对应委托书。',
    filteredBy: '当前筛选',
    resetFilters: '清空筛选',
    groupBy: '分组',
    displayMode: '显示方式',
    resultCount: '共 {count} 份委托书',
    loadingTasks: '正在读取任务…',
    noMatches: '没有符合筛选条件的任务',
    noMatchesHint: '可以调整搜索或清空筛选条件。',
    noPending: '当前没有待处理任务',
    noTasks: '当前没有任务',
    emptyHints: { pending: '可以在“我负责的”中查看已处理和其他状态的委托书。', mine: '当前没有分配给你的委托书。', brand: '当前可见品牌内还没有委托书。' },
    showMine: '查看我负责的',
    pendingTasks: '待我处理',
    allTasks: '全部任务',
    pageGroupCount: '本页{count}项',

    searchPh: '搜款号 / 委托编号 / 品名',
    title: '商品看板',
    group: { none: '不分组', progress: '按完成度', season: '按年度·季节', source: '按来源' },
    viewCard: '卡片',
    viewList: '列表',
    viewAll: '查看全部',
    done: '已完成',
    ongoing: '进行中',
    cancelled: '已作废',
    unclassified: '未分类',
    continue: '继续编制',
    view: '查看',
    emptyTitle: '暂无商品',
    noImage: '暂无图',
    field: { brand: '品牌', season: '季节', source: '来源' },
    progress: '完成度',
    empty: '暂无委托书。可从订货会或已有款号开始创建。',
  },
  source: {
    SAP_LEGACY: "SAP · 已分配款号",
    DEMO: '演示资料',
    ORDER_FAIR: '大货 · 订货会',
    MANUAL: '手动建单',
    REORDER: '5日 · 加单建议',
  },
  devSwitch: {
    label: '测试 · 切换角色',
    restore: '恢复本人',
  },
  error: {
    VALIDATION_FAILED: '提交的内容有误，请检查后重试',
    UNAUTHORIZED: '登录状态已失效，请重新登录',
    TOKEN_EXPIRED: '登录状态已失效，请重新登录',
    FORBIDDEN: '没有权限执行此操作',
    NOT_FOUND: '请求的数据不存在',
    CONFLICT: '数据冲突，请刷新后重试',
    INVALID_STATE: '当前单据状态不允许该操作',
    RATE_LIMITED: '操作过于频繁，请稍后再试',
    SAP_ERROR: 'SAP 接口返回异常，请联系管理员',
    SERVICE_UNAVAILABLE: '服务暂时不可用（数据库连接异常），请稍后重试',
    INTERNAL_ERROR: '服务器异常，请稍后再试',
    PAYLOAD_TOO_LARGE: '内容超过允许的大小，请压缩或拆分后重试',
    invalidJson: '请求内容格式不正确（不是合法 JSON），请刷新页面后重试',
    payloadTooLarge: '提交的内容超过上限{p0}，请压缩或拆分后重试',
    uploadFileTooLarge: '单个文件超过上限{p0}，请压缩后重新上传',
    uploadFileCount: '一次最多上传 {p0} 个文件，请分批上传',
    uploadUnexpectedField: '上传字段「{p0}」不被该接口接受，请检查后重试',
    uploadFormLimit: '上传表单超出限制（{p0}），请减少文件或字段后重试',
    invalidRequestEncoding: '请求格式不受支持，请刷新页面后重试',
    NETWORK: '网络连接失败，请检查网络后重试',
    UNKNOWN: '发生未知错误',
    requestId: '错误追踪号',
  },

  page: {
    todo: {
      title: '我的待办',
      desc: '当前需要您处理的事项汇总。点击卡片可查看对应单据；显示 0 表示暂无待办。',
      toCreate: '待创建（全新商品）',
      todoDrafting: '编制中（草稿）',
      pendingApproval:'等我去审批',
      rejected: '被驳回，等我修改',
      missingPrice: '还有行没填单价',
      missingUsage: '还有行没填用量',
      technicalPending: '技术资料待完成',
      approvedNotTransferred: '待同步 SAP',
      go: '去看',
    },
    dashboard: {
      title: '工作台',
      eyebrow: 'WORKBENCH',
      welcome: '欢迎回来，{name}',
      scopeTitle: '本版本重构范围',
      scopeDesc: '当前版本覆盖主流程第 5 至第 13 步，其余步骤仍在 SAP 系统中运行。',
      inScope: '本版范围',
      outOfScope: '暂不涉及',
    },
    notFound: {
      title: '页面不存在',
      desc: '访问的页面不存在或已被移除。',
      back: '返回工作台',
    },
    forbidden: {
      title: '没有访问权限',
      desc: '当前账号没有该页面的访问权限。如需开通，请联系系统管理员。',
      back: '返回工作台',
    },
  },

  integration: {
    pageHint: "EADS ↔ SAP PI 接口的连通性。探测是手动的：每次都会真的调一次 SAP，认证失败计入熔断保护。",

    tunnelTitle: 'SSH 跳板',
    tunnelHint: '本机被防火墙挡着直连不到内网端点，请求经跳板机转发（等价于 ssh -L）。业务逻辑不受影响，只是换了条路',
    tunnelConnected: '已连接，本地转发口 {port}',
    tunnelIdle: '未连接 —— 下次调用接口时自动建立',
    tunnelNotConfigured: '配置不全：需要主机、用户，以及密码或私钥',
    tunnelNoFingerprint: '未配置主机指纹，跳过了 SSH 主机校验 —— 无法察觉中间人。建议用 ssh-keyscan 取指纹后填进 .env',
    tunnelReconnect: '重连跳板',
    tunnelReconnected: '已断开，下次调用时会重新建立',
    step: {
      'jump-tcp': '① 本机 → 跳板机',
      'ssh-auth': '② SSH 登录',
      forward: '③ 跳板机 → 内网端点',
      http: '④ 端点是否应答 HTTP',
      config: '配置检查',
    },
    reachTitle: "网络连通性",
    reachHint: "只做一次 TCP 握手，不带账号密码 —— 排查时先点这个：网络不通的话，账号密码再对也不可能生效，而且认证根本不会发生，不会计入锁定次数。",
    reachRun: "检查连通性",
    enabled: "总开关",
    on: "已开启",
    off: "已关闭",
    credentials: "接口账号",
    configured: "已配置",
    missing: "未配置",
    sysGbn: "系统区分",
    endpoint: "端点地址",
    circuitClosed: "账号保护正常",
    circuitOpen: "账号保护已跳闸",
    circuitUncertain: "认证结果待确认，已暂停发送。首次启用保护或上次请求无明确回执时，请核实原进程和账号状态后由管理员复位；未知结果不计为已确认的认证失败。",
    circuitDesc: "连续认证失败 {failures} / {limit} 次，本地还允许 {remaining} 次。SAP 侧连续 3 次会锁定接口账号。",
    reset: "复位",
    resetConfirmTitle: "复位账号保护",
    resetConfirm: "复位前请先确认接口账号密码无误。密码若仍是错的，继续调用会把 SAP 侧的失败次数推向 3 次锁定。确认继续？",
    resetConfirmOk: "我已确认密码，复位",
    resetDone: "已复位",
    id: "接口号",
    interfaceName: "Interface 名",
    description: "说明",
    usedBy: "本系统用在哪",
    lastProbe: "最近一次探测",
    notProbed: "未探测",
    probe: "测试连接",
    probeStyleCd: "探测用款号",
    probeStyleCdPlaceholder: "留空用默认款号",
    probeStyleCdHint: '目录里点「测试连接」时用这个款号；留空则用服务端配置的默认值',

    catalogTitle: '接口目录',
    catalogHint: '后端团队接口清单的完整版本，可当文档查。搜索会连字段名一起搜',
    catalogCounts: '共 {total} 个 · 我方可调 {callable} 个 · 已实现 {implemented} 个 · 当前显示 {shown} 个',
    catalogSearchPh: '搜接口号 / 名称 / 描述 / 字段名',
    catalogNoMatch: '没有匹配的接口',
    dirAll: '全部',
    dirOut: 'EADS → SAP',
    dirIn: 'SAP → EADS',
    dirOutShort: '我方调用',
    dirInShort: 'SAP 推送',
    onlyInUse: '只看在用',
    onlyImplemented: '只看已实现',
    noSummary: '（接口清单里没写描述）',
    noFields: '接口定义书里没有这个接口的字段表',
    tagAsync: '异步',
    tagUnused: '未启用',
    stage: {
      done: '已实现',
      registered: '已登记',
      none: '未接入',
    },
    metaProgram: 'SAP 程序',
    metaTransport: '传输方式',
    metaCycle: '调用周期',
    metaNs: '命名空间',
    metaAdapter: '适配器',
    metaOwner: '后端担当',
    metaNote: '备注',
    fField: '字段',
    fDesc: '说明',
    fType: '类型',
    fLen: '长度',
    fSample: '示例',
    fTable: '内表',
    probeConfirmTitle: "测试接口连接",
    probeConfirm: "将真实调用一次 {id}。若认证失败会计入账号保护，本地还允许 {n} 次；SAP 侧连续 3 次会锁定接口账号。确认发起？",
    probeConfirmOk: "确认发起"
  },
  sapSpot: {
    wired: '已接入',
    notWired: '未接入',
  },

  integrationResult: {
    "OK": "连通",
    "BUSINESS_ERROR": "业务错误",
    "AUTH_FAILED": "认证失败",
    "UNREACHABLE": "网络不可达",
    "BAD_RESPONSE": "响应异常",
    "NOT_CONFIGURED": "未配置",
    "CIRCUIT_OPEN": "保护跳闸",
    "BUSY": "接口调用中",
    "SAFETY_UNAVAILABLE": "接口保护暂不可用",
    "UNKNOWN": "未知"
  },
  legacy: {
    eyebrow: '旧系统 EADS',
    listTitle: '历史委托书',
    listDesc: '旧系统迁移过来的历史数据（2019 年起），只读查阅',
    detailDesc: '旧系统历史数据，只读',
    keywordPlaceholder: '款号 / 款式号 / 款式名',
    brand: '品牌',
    year: '年度',
    state: '状态',
    stateCol: '状态',
    modelCd: '委托书款号',
    styleCd: '款式号',
    styleNm: '款式名',
    yearSeason: '年度 / 季节',
    designer: '设计师',
    colors: '配色',
    trims: '辅料',
    createdAt: '建单日期',
    empty: '没有数据',
    colorways: '配色',
    tagColor: 'Tag 色',
    washing: '洗涤说明',
    materials: '面料',
    usedPart: '使用部位',
    materialId: '面料编号',
    materialNm: '面料名',
    yardage: '用量',
    width: '幅宽',
    unit: '单位',
    unitPrice: '单价',
    ingredient: '成分',
    trimsSection: '辅料 BOM',
    trimCode: '辅料代码',
    trimName: '辅料名',
    trimType: '种类',
    colorMatchPart: '配色部位',
    consumption: '用量明细',
    memo: '备注',
    stdSizes: '基准尺寸',
    patternPart: '部位',
    size: '尺寸',
    tolerance: '公差',
    measurement: '测量方法',
    progress: '进度履历',
    statusDate: '日期',
    comment: '说明',
    modiHistory: '修改履历',
    modiTime: '时间',
    amendTable: '表',
    amendField: '字段',
    beforeAfter: '前 → 后',
    designMemos: '设计备注',
    salePrice: '售价',
    chargePattern: '纸样担当',
    chargePurchase: '采购担当',
    chargeProduction: '生产担当',
  },

  dict: {
    eyebrow: '基础数据',
    title: '基础字典',
    desc: '商品颜色（按品牌）、尺码-类别映射、面料颜色。首次导入自参考文件，此后在页面维护',
    colorTitle: '颜色字典',
    colorDesc: '商品颜色按品牌维护，材料颜色为 SAP 原材料色；两者都是下拉与检索的来源。',
    sizeTitle: '尺码字典',
    sizeDesc: '一个品牌一套尺码，按「尺码体系」分组维护；同体系下同一代码只存一条。',
    sizeSummary: '{segments} 个体系 · {sizes} 个尺码',
    sizeAdd: '添加尺码',
    sizeAddPlaceholder: '输入尺码',
    sizeAdded: '尺码 {size} 已添加',
    sizeDeleteConfirm: '确定删除尺码 {size}？删除后历史单据不受影响，但新单不可再选。',
    brandColor: '商品颜色',
    sizeCategory: '尺码类别',
    materialColor: '材料颜色',
    keywordPlaceholder: '搜代码 / 名称',
    brand: '品牌',
    colorCd: '颜色代码',
    colorNm: '英文名',
    nameZh: '中文名',
    nameKo: '韩文名',
    used: '启用',
    cate1: '大分类码',
    cate1Name: '大分类名称',
    cate1NameZh: '大分类中文名',
    cate1NameKo: '大分类韩文名',
    cate1Placeholder: '无大类可留空',
    sizeCd: '尺码代码',
    segment: '尺码段',
    segmentZh: '尺码段（中文）',
    segmentKo: '尺码段（韩文）',
    brands: '适用品牌',
    family: '色系',
    colorName: '色名',
    approxColor: '近似潘通色',
    hexCode: '近似色值',
    pantoneCd: '潘通色号',
    approxHint: '色块由色系与色名推算，仅用于界面示意；正式对色请以实物色卡或官方潘通色值为准。',
    notCollected: '未采集',
    add: '新增',
    addTitle: '新增字典项',
    editTitle: '编辑字典项',
    deleteConfirm: '确定删除这条字典项吗？已录入单据里的旧值不受影响，但下拉/检索将不再出现。',
  },
  sapTransfer: {
    duration: '耗时',
    inProgress: '进行中',
    states: { SUCCESS: '已传送', FAILED: '未成功', SENDING: '传送中', PENDING: '待传送', RECONCILE: '结果待核对' },
    empty: '还没有传送记录 —— 审批通过的委托书传 SAP 后会出现在这里。',
    title: 'SAP 传送状态',
    desc: '委托书传给 SAP（SP0070）的每一次记录，失败的可以人工重发',
    refresh: '刷新',
    allStatus: '全部状态',
    time: '开始时间',
    sheet: '委托书',
    channel: '通道',
    status: '状态',
    error: '失败原因',
    by: '操作人',
    actions: '操作',
    resend: '重发',
    resendTitle: '重发 SAP 传送',
    resendConfirm: '重新传送委托书 {model} ？会按最新内容完整重走一遍（含预检）。',
    resendOk: '重发成功',
  },

};
